<template>
  <div>
    <TabNav :scroll="scroll" :scrollActived="scrollActived"/>
    <ContactBar />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>

import ContactBar from './components/ContactBar';
import TabNav from "./components/TabNav.vue"
import Footer from "./components/Footer.vue"
export default {
  name: 'App',
  components: {
    ContactBar,
    TabNav,
    Footer
  },
  data() {
    return {
      scroll: 0,
      scrollActived: ''
    }
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll,true)
  },
  methods:{
      handleScroll(){
          this.scroll = this.$route.path !='/home' ? 100 : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      },
      scrollChangeTab(id) {
          this.scrollActived = id
      }
  },
  //销毁,否则跳到别的路由还是会出现
  unmounted(){
      window.removeEventListener('scroll',this.handleScroll)
  }
}
</script>

<style lang="scss">
#app,html,body {
  margin: 0;
}
@include pc1024() {
  #app,html,body {
    min-width: 1190Px;
  }
}
@include h5() {
  min-width: 100vh;
}
</style>
